import React from "react";
import "./pages.css";
import {UseCaseList} from "../Components/Contents/UseCaseList";
import Button from "../Components/BasicComponents/Button";
import {DefaultParameters} from "../Api/ApiCallMethod";
import {Link} from "react-router-dom";
import MetaData from "../Components/MetaData/MetaData";

export default class UseCases extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabList: [
                {Name: "Patents"},
                {Name: "Trademark"},
            ],
            activeTab: {Name: "Patents"}
        }
    }


    render() {
        let {setUseCaseID, scrollToTop, openDetailPage} = this.props;
        return (
            <div className="feature-layout">
                <h1 className="header-text">
                    AI-Powered IP Use Cases
                </h1>
                <div className="main-description">
                    The gamut of IP Use Cases powered by AI Agents
                </div>
                {/*<div className="feature-tab-division">*/}
                {/*    <TabBar tabList={this.state.tabList} activeTab={this.state.activeTab}*/}
                {/*            onChange={(activeTab) => this.changeTab.bind(this, activeTab)}/>*/}
                {/*</div>*/}
                <UseCaseShowCase type={"all"} setUseCaseID={setUseCaseID} scrollToTop={scrollToTop} openDetailPage={openDetailPage}/>


            </div>
        );
    }

}

export class UseCaseShowCase extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    onSignUp = () => {
        let productUrl = DefaultParameters().ProductURL
        productUrl += DefaultParameters().LoginRoute
        window.open(productUrl, '_blank');
    }

    openUseCaseDetails = (id) => {
        let {setUseCaseID, scrollToTop, openDetailPage} = this.props;
        setUseCaseID(id);
        scrollToTop();
        openDetailPage();

    }

    getFeatureRow = (feature, id) => {
        let featureInfo = UseCaseList[feature];
        return (
            <div className="feature-info-row" key={id}>
                <MetaData keyword={"ai-ip-use-cases"}/>
                <div className="feature-info-text">
                    <div className="feature-info-number">
                        {id + 1 < 10 ? `0${id + 1}` : id + 1}
                    </div>
                    <h2 className="header-text feature-info-title">
                        {featureInfo.Name}
                    </h2>
                    <div className="feature-info-slogan">
                        - {featureInfo.SubHeader} -
                    </div>
                    <p className="feature-info-description">
                        {featureInfo.Description}
                    </p>
                    <div className="feature-info-button-row">
                        <Link className="default-secondary-btn"
                              to={`/${featureInfo.LinkName}`}
                              onClick={this.openUseCaseDetails.bind(this, feature)}
                        >
                            Read More
                        </Link>

                        {
                            featureInfo.Available ?
                                <Button type={"primary"} onClick={this.onSignUp.bind(this)}

                                        width={"140px"}>
                                    Get Started
                                </Button>


                                :

                                <Button type={"buttonLink"} linkedRoute={`/request_early_access`}

                                        width={"auto"}>
                                    Request Early Access
                                </Button>

                        }
                    </div>

                </div>

                <div className="feature-info-illustration-container">
                    <div className="feature-info-illustration">
                        <img src={featureInfo.Illustration} height={"100%"} alt={featureInfo.IllustrationDescription}/>
                    </div>
                </div>

            </div>
        )
    }

    render() {
        return (
            <div className="feature-list">
                {
                    Object.keys(UseCaseList).map((feature, fid) =>
                        this.getFeatureRow(feature, fid)
                    )
                }
            </div>
        );
    }
}